// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"bcf2b011","488":"e354f241","977":"0b30c87d"}[chunkId] + ".chunk.js";
};